import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';

import { UserService } from './core/user.service';
import { User } from './models/user.model';
import { DeviceService } from './core/device.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {

  user?: User;
  isLoggedIn: boolean = false;
  deviceSize?: 'mobile' | 'tablet' | 'desktop';
  sidebarEnabled: boolean = false;

  showPremiumPopup: boolean = true;

  constructor(
    private translate: TranslateService,
    private userService: UserService,
    private router: Router,
    private deviceService: DeviceService
  ) {
    this.userService.loadUser().subscribe();
    this.userService.getUser().subscribe(user => {
      this.user = user;
    });
    this.translate.setDefaultLang('en');
    let lang = this.user?.language ? this.user.language : this.translate.getBrowserLang();
    lang = 'de';
    this.translate.use(lang?.match(/en|de/) ? lang : 'en');
    document.documentElement.lang = lang ? lang : 'en';
  }

  ngOnInit() {
    this.userService.isLoggedIn.subscribe(loggedIn => this.isLoggedIn = loggedIn);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    this.deviceSize = this.deviceService.getDeviceSize();
    this.userService.isLoggedIn.subscribe((loggedIn) => {
      this.sidebarEnabled = loggedIn;
    });
  }

  showBack(): boolean {
    const routesToShowFooter = ['/home', '/courses', '/stats', '/settings'];
    return !routesToShowFooter.includes(this.router.url);
  }

  showPremium(): boolean {
    const routesToShowFooter = ['/home', '/courses', '/stats', '/settings'];
    return routesToShowFooter.includes(this.router.url);
  }

  showActions(): boolean {
    return /^\/courses\/[^\/]+$/.test(this.router.url) || /^\/sets\/[^\/]+$/.test(this.router.url);
  }

  showHeader(): boolean {
    if (!this.isLoggedIn) {
      return false;
    }
    const routesToNotShowFooter = ['/onboarding'];
    return !routesToNotShowFooter.includes(this.router.url);
  }

  showFooter(): boolean {
    if (!this.isLoggedIn) {
      return false;
    }
    const routesToShowFooter = ['/home', '/courses', '/stats', '/settings'];
    return routesToShowFooter.includes(this.router.url);
  }
}
